import { render } from "./backdrop.vue?vue&type=template&id=4680f508&scoped=true"
import script from "./backdrop.vue?vue&type=script&lang=js"
export * from "./backdrop.vue?vue&type=script&lang=js"

import "./backdrop.vue?vue&type=style&index=0&id=4680f508&lang=css&scoped=true"

import exportComponent from "/var/www/test.mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4680f508"]])

export default __exports__